import Joi from 'joi';

export const isPrimarySchema = Joi.boolean().valid(true, false).required().messages({
  'boolean.base': 'Is Primary has to be a boolean value',
  'any.only': 'Is Primary can only be true or false',
  'any.required': 'Is Primary is required field',
});

export const mongoObjectIdSchema = Joi.string().hex().length(24);

export const influencerIdSchema = mongoObjectIdSchema.messages({
  'any.required': 'Influencer ID is missing',
});

export const affiliateIdSchema = Joi.number().positive().messages({
  'number.base': 'Invalid Affiliate ID',
  'number.positive': 'Invalid Affiliate ID',
});

export const websiteUrlSchema = Joi.string()
  .required()
  .pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i)
  .messages({
    'any.required': 'Website URL is required',
    'string.empty': 'Website URL cannot be empty',
    'string.pattern.base': 'Please enter a valid website URL',
  });
